import { render, staticRenderFns } from "./ViewCertificateModule.vue?vue&type=template&id=bca30700&scoped=true&"
import script from "./ViewCertificateModule.vue?vue&type=script&lang=js&"
export * from "./ViewCertificateModule.vue?vue&type=script&lang=js&"
import style0 from "./ViewCertificateModule.vue?vue&type=style&index=0&id=bca30700&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca30700",
  null
  
)

export default component.exports